import { useEffect, useMemo, useState } from "react";

import { nomesDosFornecedores } from "@/lib/fornecedores";

// Sugestões do campo Fornecedor: os nomes já usados nas compras + a ficha de Pessoas › Fornecedores
// (no servidor, por loja — até a v1.5.812 vinha do navegador e sumia no logout, achado #85).
export default function useFornecedoresSugeridos(lotes) {
  const [cadastrados, setCadastrados] = useState([]);
  useEffect(() => {
    let vivo = true;
    nomesDosFornecedores().then((nomes) => { if (vivo) setCadastrados(nomes); });
    return () => { vivo = false; };
  }, []);
  return useMemo(() => {
    const nomes = new Set([...lotes.map((l) => l.supplier), ...cadastrados].filter(Boolean));
    return [...nomes].sort((a, b) => a.localeCompare(b, "pt-BR"));
  }, [lotes, cadastrados]);
}
